import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ProductStatus from '../ProductStatus';
import OrderAvailabilityBadges from '../OrderAvailabilityBadges';
import { basketQuantityLimit } from '../../utils/orderAvailability';
import BasketSummary from './BasketSummary';
import { MAX_QUANTITY_TOOLTIP, renderUnitPrice, renderTotalPrice } from './basketUtils';
import ProductAvailabilityNote from '../ProductAvailabilityNote';
import ProductPhoto from '../ProductPhoto';
import shoppingCartIcon from '../../assets/images/shopping-cart.png';

const BasketDesktop = ({
  products,
  onChangeQuantity,
  removeProductFromCart,
  close,
  allowToOrder = false,
}) => {
  const isEmpty = products.length === 0;

  return (
    <>
      <div className="modal-header basket-modal-header">
        <h4
          id="basket-title"
          className="modal-title w-100 text-center m-0 d-flex justify-content-center align-items-center basket-header-title"
          style={{ fontWeight: 600 }}
        >
          <img
            src={shoppingCartIcon}
            alt=""
            className="basket-header-icon"
            style={{ width: '22px', height: '22px', marginRight: '6px', flexShrink: 0 }}
          />
          <span>Кошик товарів</span>
        </h4>
        <button
          type="button"
          className="close"
          aria-label="Закрити"
          onClick={close}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div className="modal-body basket-modal-body">
        <div className="container basket-modal-container">
          {products.length === 0 ? (
            <div className="py-2 text-center">
              <p className="mb-0 font-weight-bold">Кошик пустий</p>
            </div>
          ) : (
      products.map((product, index) => {
        const { quantity } = product;
        const atMaxQuantity = quantity >= basketQuantityLimit(product, allowToOrder);
        const isLast = index === products.length - 1;
        return (
          <div key={product.id + product.name} className={isLast ? '' : 'border-bottom pb-3 mb-3'}>
            <div className="row no-gutters align-items-center">
              <div className="col-xl-1 col-lg-1 col-12 px-0">
                <ProductPhoto image={product.image} name={product.name} price={product.price}
                  personalDiscount={product.personalDiscount} productDiscount={product.productDiscount}
                  discountedPrice={product.discountedPrice} className='cartImage' />
              </div>
              <div className="col-xl-5 col-lg-5 col-12 px-0">
                <h6 className="m-0" style={{ fontWeight: 600 }}>{product.name}</h6>
                {allowToOrder ? <OrderAvailabilityBadges product={product} /> : <ProductStatus product={product} isBasket />}
                {product.maxQuantity > 0 && product.maxQuantity <= 3 &&
                  <ProductAvailabilityNote kind='low-stock' quantity={product.maxQuantity} productId={product.id} />}
              </div>
              <div className="col-xl-2 col-lg-2 col-12 px-0">
                {renderUnitPrice(product)}
              </div>
              <div className="col-xl-2 col-lg-3 col-12 px-0 disable-select">
                <div style={{ display: 'inline-flex', alignItems: 'center', border: '1px solid #dee2e6', borderRadius: '6px', overflow: 'visible' }}>
                  <span
                    onClick={() => onChangeQuantity(false, product.id)}
                    style={{ cursor: 'pointer', padding: '4px 10px', color: '#6c757d', fontSize: '1rem' }}
                    role="button"
                    tabIndex={0}
                  >
                    -
                  </span>
                  <span style={{ padding: '4px 12px', minWidth: '28px', textAlign: 'center', fontSize: '1rem' }}>
                    {quantity} шт
                  </span>
                  <OverlayTrigger
                    placement="top"
                    trigger={['hover', 'focus']}
                    overlay={atMaxQuantity ? (
                      <Tooltip id={`basket-max-qty-${product.id}`} className='basket-limit-tooltip'>
                        <strong>{MAX_QUANTITY_TOOLTIP}</strong>
                      </Tooltip>
                    ) : <span />}
                  >
                    <span
                      className="basket-quantity-plus-wrapper"
                      onClick={() => onChangeQuantity(true, product.id)}
                      style={{ cursor: 'pointer', padding: '4px 10px', color: '#6c757d', fontSize: '1rem' }}
                      role="button"
                      tabIndex={0}
                    >
                      +
                    </span>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="col-xl-1 col-lg-1 col-12 px-0 d-flex align-items-center">
                {renderTotalPrice(product)}
              </div>
              <div className="col-xl-1 col-lg-1 col-12 px-0 d-flex align-items-center justify-content-center">
                <button
                  type="button"
                  className="btn btn-link p-0 border-0 cart-delete-btn"
                  style={{ cursor: 'pointer' }}
                  onClick={() => removeProductFromCart(product.id)}
                  aria-label="Видалити товар з кошику"
                  title="Видалити товар з кошику"
                >
                  <i className="bi bi-trash-fill cart-delete-icon" style={{ fontSize: '1.25rem' }} />
                </button>
              </div>
            </div>
          </div>
        );
      })
          )}
        </div>
      </div>

      <div className="modal-footer basket-modal-footer py-2 px-3">
        <div className="container p-0 basket-modal-container">
          <div className="text-right">
            {!isEmpty && <BasketSummary products={products} />}
            <div className="basket-footer-buttons" style={{ marginTop: isEmpty ? 0 : '12px' }}>
              <div className="d-flex justify-content-between align-items-center">
                <button type="button" className="btn btn-outline-secondary" onClick={() => close()}>
                  <i className="bi bi-arrow-left mr-1" />
                  Повернутись до покупок
                </button>
                {!isEmpty && <a className="btn btn-dark" href="/checkout">Перейти до оформлення</a>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasketDesktop;
